<template>
  <Section title="projects">
    <div class="projects-wrap">
      <div class="projects__container">
        <Project v-for="project in projects" :key="project.id" :project="project" />
      </div>
    </div>
  </Section>
</template>

<script>
import Project from "@/components/globals/Project";

export default {
  name: "ProjectsSection",
  components: {
    Project
  },
  data() {
    return {
      projects: [
        {
          id: 1,
          title: "Vue Tab Tracker",
          imageURL: "https://i.imgur.com/aSDaS3f.jpg",
          description:
            "Vue, Node & Express web app for keeping track of guitar tabs",
             projectURL:"https://github.com/adele-angel/vue-tab-tracker"
        },
        {
          id: 2,
          title: "System Performance Monitor",
          imageURL: "https://i.imgur.com/XmtJJJS.jpg",
          description:
            "React, Node & Express app for monitoring system performance",
            projectURL:"https://github.com/adele-angel/system-monitor"
        },
        {
          id: 3,
          title: "ngMarket",
          imageURL: "https://i.imgur.com/9ajefYR.jpg",
          description:
            "Angular 7, Node and Express E-commerce / online supermarket webstore",
            projectURL:"https://github.com/adele-angel/ngMarket"
        },
        {
          id: 4,
          title: "Vacation Scanner",
          imageURL: "https://i.imgur.com/4vnJutk.jpg",
          description:
            "Vacation booking website using React, MongoDB, Node & Express",
             projectURL:"https://github.com/adele-angel/VacationScanner"
        },
        {
          id: 5,
          title: "Weather App",
          imageURL: "https://i.imgur.com/OvR0hpj.jpg",
          description:
            "Weather app using Angular framework and NgRX as state management library",
            projectURL:"https://github.com/adele-angel/Vue-Image-Gallery"
        },
        {
          id: 6,
          title: "Vue Image Gallery",
          imageURL: "https://i.imgur.com/IKX62xu.jpg",
          description:
            "Image gallery app using Vue framework with TypeScript & Flickr API",
             projectURL:"https://github.com/adele-angel/Vue-Image-Gallery"
        }
      ]
    };
  }
};
</script>